// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__N34uG","fixed":"styles_fixed__5WMev"};